import {
  Backdrop,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CloseoutFormFields from "../../../components/CloseoutFormFields/CloseoutFormFields";
import DocumentUploadInput from "../../../components/DocumentUploadInput/DocumentUploadInput";
import { Button, LoadingSpinner } from "pepsico-ds";
import ModalPopUp from "../../../shared/modalPopUp";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { CloseOutActions } from "../../../redux/closeoutslice/closeoutSlice";
import UseUploadInChunks from "../../../shared/Hooks/FileUploadInChunks";
import { saveFiles } from "../../../services/intakeFormService";
import urls from "../../../configmap/config.json";
type viewRequestPropes = {
  open: boolean;
  onclose: () => void;
  enabled: boolean;
  closeOutData: any;
  ontableReaload: () => void;
};
const ViewCloseOutRequest = ({
  open,
  onclose,
  enabled,
  closeOutData,
  ontableReaload,
}: viewRequestPropes) => {
  const [scroll, setScroll] = useState<DialogProps["scroll"]>("paper");
  const [Loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const { projectDetails } = useSelector((state: any) => state.project);
  const {
    isUploading,
    files,
    fileClassificationSelection,
    uploadedFilesSuccess,
    uploadedFiles,
  } = useSelector((state: any) => state.closeOut);
  const { gpid } = useSelector((state: any) => state.auth);
  const { fileUploadInChuncks } = UseUploadInChunks();
  const dispatch = useDispatch();

  const submitRequest = async () => {
    setOpenModal(false);
    dispatch(CloseOutActions.setIsuploading(true));
    dispatch(CloseOutActions.setDisplayProgress(true));
    setLoading(true);
    const filesToUpload = files.filter((file: any) => {
      return !uploadedFilesSuccess.includes(file.name) && file.size > urls.minFileSize
    });
    if (filesToUpload.length === 0) {
      dispatch(
        CloseOutActions.setErrorMessage(
          "All selected files have already been uploaded."
        )
      );
      dispatch(CloseOutActions.setIsuploading(false));
      return;
    }
    let localConstructedFiles: any[] = [];
    for (const file of filesToUpload) {
      try {
        const classification = fileClassificationSelection[file.name];
        // Upload the file in chunks and store the constructed files
        await fileUploadInChuncks(file, localConstructedFiles, classification);
        // Update Redux state with the uploaded file's name
        dispatch(
          CloseOutActions.setUploadedFiles([...uploadedFiles, file.name])
        );
        dispatch(
          CloseOutActions.setUploadedfileSuccess([
            ...uploadedFilesSuccess,
            file.name,
          ])
        );
      } catch (error) {
        console.error(`Error uploading file ${file.name}:`, error);
      }
    }
    // After all files are uploaded, dispatch the constructed files to the store
    dispatch(CloseOutActions.setConstructedFiles(localConstructedFiles));
    dispatch(CloseOutActions.setDisplayProgress(false));
    if (localConstructedFiles.length) {
      dispatch(CloseOutActions.setIsuploading(false));
      try {
        const closeoutProjectDetails = projectDetails.data[0];
        const saveFilesPayload = [
          {
            data: {
              project_id: closeoutProjectDetails.project_id, // Extract project_id from intakeProjectDetails
              user_id: gpid, // Static user_id
            },
            attached_files: localConstructedFiles, // Use the historicalFiles for attached files
          },
        ];

        // Call the API to save the files
        await saveFiles(saveFilesPayload);
        // navigate("/consulting-knowledge-management/engagement-history");
        onclose();
        ontableReaload();
        dispatch(CloseOutActions.resetAll());
        // navigate('/engagement-history', { state: { message: 'Closeout Form', data: combinedDataArray } });
      } catch (error: any) {
        // setCloseoutError(error);
      } finally {
        setLoading(false);
        dispatch(CloseOutActions.resetAll());
      }
    }
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={onclose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        fullWidth
        maxWidth="lg"
        PaperProps={{
          sx: {
            width: "53%",
            maxHeight: "100%",
            height: "100%",
            position: "absolute",
            right: 0,
            top: 0,
            margin: 0,
          },
        }}
      >
        <DialogTitle
          sx={{ padding: "10px 24px", backgroundColor: "#eff5fc" }}
          id="scroll-dialog-title"
        >
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "flex-end",
                cursor: "pointer",
              }}
              onClick={onclose}
            >
              <CloseIcon fontSize="small" />
            </div>
            <div>
              <Typography
                // className='typography-text'
                sx={{
                  alignSelf: "center",
                  fontFamily: '"Inter", sans-serif',
                  fontSize: "16px",
                  fontWeight: "700",
                }}
                variant="h6"
                gutterBottom
              >
                Upload Engagement Data - Close Out Form
              </Typography>
            </div>
          </div>
        </DialogTitle>
        <DialogContent dividers={scroll === "paper"}>
          <DialogContentText
            id="scroll-dialog-description"
            // ref={descriptionElementRef}
            tabIndex={-1}
          ></DialogContentText>
          <div>
            <CloseoutFormFields
              formData={closeOutData}
              handleClose={onclose}
              handleChange={() => {}}
              inputError={{}}
              closeoutErrors={{}}
              closeoutOnFocus={() => {}}
              closeoutOnBlur={() => {}}
              mode={"edit"}
            >
              <DocumentUploadInput />
            </CloseoutFormFields>
          </div>
        </DialogContent>
        <DialogActions>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}></div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Button
                size="medium"
                text="Cancel"
                variant="secondary"
                onClick={onclose}
              />
              <Button
                size="medium"
                text="Submit"
                variant="primary"
                disabled={Loading || enabled}
                onClick={() => setOpenModal(true)}
              />
            </div>
          </div>
        </DialogActions>
        <Backdrop
          open={Loading}
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <LoadingSpinner
            size={{
              height: "60px",
              width: "60px",
            }}
          />
          <div className="$font-heading-h6-medium" style={{ color: "#fff" }}>
            {isUploading ? "Uploading the files..." : "Submitting the form..."}
          </div>
        </Backdrop>
      </Dialog>
      <ModalPopUp
        open={openModal}
        handleClose={() => setOpenModal(false)}
        handleOnSubmit={submitRequest}
      />
    </>
  );
};
export default ViewCloseOutRequest;
